(async () => {
    const baseComponent = await import(window.theme.modules.baseComponent);

    customElements.define('main-nav', class extends baseComponent.default {
        elements = {
            dropdowns: '*[data-dropdown]'
        };

        modalInit = false;

        render() {
            this.$dropdowns
                .filter(drop => drop.hasAttribute('data-offset-drop'))
                .map(dropdown => {
                    const rect = dropdown.getBoundingClientRect();
                    if (window.innerWidth - rect.x < 600) {
                        dropdown.classList.add('@drop-reverse');
                    }
                });
        }

        reRender() {
            if (this.closest('modal-popup') && !this.modalInit) {
                this.modalInit = true;
                this.$dropdowns.forEach(dropdown => {
                    dropdown.addEventListener('click', (e) => {
                        const dropId = e.currentTarget.dataset.dropdown;
                        const target = this.querySelector(`[data-dropby="${dropId}"]`);

                        if (target) {
                            e.preventDefault();
                            target.classList.toggle('!active');
                            e.currentTarget.classList.toggle('!active');
                        }
                    });
                });
            }
        }
    });
})();